export const convert_to_readable = (str) => {
    //snake case
    if (!str)   return '';
    if (str.includes('_')) {
        return str.replace(/_/g, ' ').replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    }
    //camel case
    let words = str.match(/[A-Za-z][a-z]*/g) || [];
    return words.map(word => (word.charAt(0).toUpperCase() + word.substring(1))).join(" ");
}